export default __webpack_public_path__ + "static/media/sport.2769b66c.png";